import { getSdk } from "../services/sdkService";
export async function isForceLogout(error) {
  //const userLogged = getAppState().userLogged;
  const sdk = await getSdk();
  const loggedIn = await sdk.authenticationManager.isLoggedIn();
  const errorStatus =
    error && error.status ? error.status : error.response && error.response.status ? error.response.status : null;
  if (loggedIn && (errorStatus === 403 || errorStatus === 401 || errorStatus === 407)) {
    return true;
  }
  return false;
}
